// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import useTenantLocalization from "../hooks/useTenantLocalization";

/**
 * Applies tenant-specific localization to the i18n instance.
 * - Sets language based on localization.default_language from the backend.
 * - Renders nothing.
 */
const TenantLocalization = () => {
  const { language } = useTenantLocalization();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (language && i18n.language !== language) {
      i18n.changeLanguage(language);
    }
  }, [language, i18n]);

  return null;
};

export default TenantLocalization;
